import repository from "../Repository";

export default {
  /**
   * 検索参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`evacuee_info_list`, payload, {
      headers: {
        s: screenId
      }
    });
  },
  /**
   * 詳細参照API
   * @param {*} screenId 画面ID
   * @param {*} userId ユーザーID
   * @param {*} disasterNo 災害番号
   */
  async detail(screenId, userId, disasterNo) {
    return await repository.post(
      `evacuee_info_detail`,
      {
        user_id: userId,
        disaster_no: disasterNo
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
